import { render, staticRenderFns } from "./TreatmentSectionAdvForm.vue?vue&type=template&id=bac51cfa&scoped=true"
import script from "./TreatmentSectionAdvForm.vue?vue&type=script&lang=js"
export * from "./TreatmentSectionAdvForm.vue?vue&type=script&lang=js"
import style0 from "./TreatmentSectionAdvForm.vue?vue&type=style&index=0&id=bac51cfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac51cfa",
  null
  
)

export default component.exports